import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';

const TermsCondition: React.FC = () => {
  const { t } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return (
    <div style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <section className="terms_heros">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="main-title">
                <h2>{t('Terms_&_Conditions')}</h2>
                <p>{t('Trust. Expertise. Results.')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="px-3 px-md-5 mt-5">
        <Row className="justify-content-center">
          <Col lg={12}>
            <div className="terms-box p-4 bg-light rounded-0">
              <section className="mb-4">
                <h5>1. {t('Introduction')}</h5>
                <p>{t('Terms_Intro')}</p>
              </section>
              <section className="mb-4">
                <h5>2. {t('Acceptance_of_Terms')}</h5>
                <p>{t('Terms_Acceptance')}</p>
              </section>
              <section className="mb-4">
                <h5>3. {t('Changes_to_Terms')}</h5>
                <p>{t('Terms_Changes')}</p>
              </section>
              <section className="mb-4">
                <h5>4. {t('User_Registration')}</h5>
                <p>{t('Terms_Registration')}</p>
              </section>
              <section className="mb-4">
                <h5>5. {t('Use_of_Services')}</h5>
                <p>{t('Terms_Use')}</p>
              </section>
              <section className="mb-4">
                <h5>6. {t('Prohibited_Activities')}</h5>
                <ul>
                  <li>{t('Prohibited_1')}</li>
                  <li>{t('Prohibited_2')}</li>
                  <li>{t('Prohibited_3')}</li>
                  <li>{t('Prohibited_4')}</li>
                  <li>{t('Prohibited_5')}</li>
                </ul>
              </section>
              <section className="mb-4">
                <h5>7. {t('Privacy_Policy')}</h5>
                <p>{t('Terms_Privacy')}</p>
              </section>
              <section className="mb-4">
                <h5>8. {t('Intellectual_Property')}</h5>
                <p>{t('Terms_Intellectual')}</p>
              </section>
              <section className="mb-4">
                <h5>9. {t('Third_Party_Links')}</h5>
                <p>{t('Terms_ThirdParty')}</p>
              </section>
              <section className="mb-4">
                <h5>10. {t('Limitation_of_Liability')}</h5>
                <p>{t('Terms_Liability')}</p>
              </section>
              <section className="mb-4">
                <h5>11. {t('Indemnification')}</h5>
                <p>{t('Terms_Indemnification')}</p>
              </section>
              <section className="mb-4">
                <h5>12. {t('Termination')}</h5>
                <p>{t('Terms_Termination')}</p>
              </section>
              <section>
                <h5>13. {t('Contact_Us')}</h5>
                <p>
                  {t('Terms_Contact')}{' '}
                  <a href="mailto:info@shahlpo.ae">info@shahlpo.ae</a>
                </p>
              </section>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TermsCondition;
